import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar" }
const _hoisted_3 = { class: "page-bar-main" }
const _hoisted_4 = { class: "page-filters pf-bar" }
const _hoisted_5 = { class: "pf-search" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "intake-wrap",
  style: {"max-width":"800px"}
}
const _hoisted_8 = { class: "av" }
const _hoisted_9 = { class: "intake-info" }
const _hoisted_10 = { class: "intake-name" }
const _hoisted_11 = { class: "intake-sub" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "intake-act" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "full-table" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "no-emp-badge",
  title: "Not linked to a Team Hub employee. Link them from the employee's page (Sign-in accounts)."
}
const _hoisted_19 = {
  key: 1,
  class: "user-emp-sub"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = ["title"]
const _hoisted_22 = { style: {"text-align":"center"} }
const _hoisted_23 = { class: "row-menu" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "row-menu-dropdown"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { colspan: "42" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { style: {"max-height":"200px","overflow":"auto"} }
const _hoisted_34 = ["href"]
const _hoisted_35 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_36 = { class: "form-wrapper slide-up" }
const _hoisted_37 = { class: "form-close" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_tip = _resolveComponent("info-tip")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_pdf_pop_up = _resolveComponent("pdf-pop-up")!
  const _component_add_edit_public_user = _resolveComponent("add-edit-public-user")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "page-bar-sub" }, "Settings", -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[17] || (_cache[17] = _createTextVNode("Standard Users", -1)),
          _createVNode(_component_info_tip, { text: "Standard users are the log ins for the non-admin users of your Ironbook. They see published items for their locations and departments. When you add a standard user or give access to a registration, they're linked to the employee record with the same phone number, or a new employee record is created and opened so you can complete it. Links can be changed from the employee's page." })
        ])
      ]),
      _createElementVNode("div", {
        class: "btn-light",
        onClick: _cache[0] || (_cache[0] = () => { _ctx.pdfURL = '/ironbook-permissions-guide.pdf'; _ctx.showPDF = true; })
      }, "Permissions Guide")
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[19] || (_cache[19] = _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            "aria-hidden": "true"
          }, [
            _createElementVNode("circle", {
              cx: "11",
              cy: "11",
              r: "7"
            }),
            _createElementVNode("path", { d: "M21 21l-4.35-4.35" })
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQ) = $event)),
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search())),
            placeholder: "Search",
            "aria-label": "Search"
          }, null, 544), [
            [_vModelText, _ctx.searchQ]
          ])
        ]),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.active) = $event))
        }, [...(_cache[20] || (_cache[20] = [
          _createElementVNode("option", { value: true }, "Active", -1),
          _createElementVNode("option", { value: false }, "Inactive", -1)
        ]))], 512), [
          [_vModelSelect, _ctx.active]
        ]),
        (_ctx.$store.state.user.isAdmin)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedLocation) = $event)),
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.search()))
            }, [
              _cache[21] || (_cache[21] = _createElementVNode("option", { value: "ALL" }, "All Locations", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.locations, (loc, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: loc
                }, _toDisplayString(loc), 9, _hoisted_6))
              }), 128))
            ], 544)), [
              [_vModelSelect, _ctx.selectedLocation]
            ])
          : _createCommentVNode("", true),
        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "pf-spacer" }, null, -1)),
        _createElementVNode("div", {
          class: "btn",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printSignUpSheet()))
        }, "Sign-up Sheet"),
        _createElementVNode("div", {
          class: "btn",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showInviteFn()))
        }, "Send Invitation Text"),
        (_ctx.$store.state.user.isAdmin)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[8] || (_cache[8] = () => { _ctx.userToEdit = null; _ctx.showAddEditUser = true }),
              class: "add-btn"
            }, "Add"))
          : _createCommentVNode("", true)
      ]),
      (_ctx.$store.state.user.isAdmin && _ctx.awaitingAccess.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "intake-head" }, "Awaiting Access", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.awaitingAccess, (user) => {
              return (_openBlock(), _createElementBlock("div", {
                key: user.ID,
                class: "intake-row"
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.initials(user)), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(user.FirstName) + " " + _toDisplayString(user.LastName), 1),
                  _createElementVNode("div", _hoisted_11, [
                    (user.Location)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(user.Location) + " · ", 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(_ctx.formatPhone(user.Phone)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: "btn",
                    onClick: ($event: any) => (_ctx.editUser(user))
                  }, "Give access", 8, _hoisted_14),
                  _createElementVNode("div", {
                    class: "btn btn-light",
                    onClick: ($event: any) => (_ctx.deleteUser(user))
                  }, "Delete", 8, _hoisted_15)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("table", _hoisted_16, [
        _createElementVNode("tbody", null, [
          _cache[25] || (_cache[25] = _createElementVNode("tr", { class: "table-labels" }, [
            _createElementVNode("td", null, "Name"),
            _createElementVNode("td", null, "Phone"),
            _createElementVNode("td", null, "Location"),
            _createElementVNode("td", null, "Last Login"),
            _createElementVNode("td", null, "# of Visits"),
            _createElementVNode("td", { style: {"padding":"0"} })
          ], -1)),
          _cache[26] || (_cache[26] = _createElementVNode("tr", { style: {"padding":"0","height":"0"} }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              ((_ctx.active && !user.InActive) || (!_ctx.active && user.InActive))
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(user.FirstName) + " " + _toDisplayString(user.LastName), 1),
                      (!user.EmployeeID)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "No employee"))
                        : _createCommentVNode("", true),
                      (user.EmployeeName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Employee: " + _toDisplayString(user.EmployeeName), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        href: 'tel:'+user.Phone,
                        target: "_blank"
                      }, _toDisplayString(_ctx.formatPhone(user.Phone)), 9, _hoisted_20)
                    ]),
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(user.Location), 1),
                      (user.LocationsAll.length > 1)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            title: user.LocationsAll.slice(1).join(', '),
                            style: {"cursor":"help"}
                          }, " +" + _toDisplayString(user.LocationsAll.length - 1), 9, _hoisted_21))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(user.LastLogin), 1),
                    _createElementVNode("td", null, _toDisplayString(user.NumLogins), 1),
                    _createElementVNode("td", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "row-menu-btn",
                          onClick: _withModifiers(($event: any) => (_ctx.toggleRowMenu(user)), ["stop"])
                        }, [
                          _createVNode(_component_svg_icon, { icon: "dots" })
                        ], 8, _hoisted_24),
                        (_ctx.openMenuID == user.ID)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createElementVNode("a", {
                                onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.getSignOffs(user))), ["prevent"])
                              }, "Sign Offs", 8, _hoisted_26),
                              (_ctx.$store.state.user.isAdmin)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("a", {
                                      onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.editUser(user))), ["prevent"])
                                    }, "Edit", 8, _hoisted_27),
                                    _createElementVNode("a", {
                                      onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.signInAsUser(user))), ["prevent"])
                                    }, "Sign In As", 8, _hoisted_28),
                                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "row-menu-divider" }, null, -1)),
                                    _createElementVNode("a", {
                                      class: "row-menu-delete",
                                      onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.deleteUser(user))), ["prevent"])
                                    }, "Delete", 8, _hoisted_29)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (user.showSignOffs)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                    _createElementVNode("td", _hoisted_31, [
                      (!user.signOffs.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, "No Sign Offs"))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.signOffs, (signOff, j) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'r'+j
                          }, [
                            _createTextVNode(_toDisplayString(signOff.DateDisplay) + " - ", 1),
                            _createElementVNode("a", {
                              href: '/playbook/'+signOff.Slug,
                              target: "_blank"
                            }, _toDisplayString(signOff.NodeName), 9, _hoisted_34),
                            _createTextVNode(" - " + _toDisplayString(signOff.Signature), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ], 2),
    (_ctx.showInvite)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[9] || (_cache[9] = () => { _ctx.showInvite = false })
              }, "×")
            ]),
            _cache[27] || (_cache[27] = _createElementVNode("h3", null, "Phone", -1)),
            _createVNode(_component_phone_input, {
              modelValue: _ctx.invitePhone,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.invitePhone) = $event)),
              placeholder: "Phone"
            }, null, 8, ["modelValue"]),
            _cache[28] || (_cache[28] = _createElementVNode("h3", null, "Message", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.inviteMsg) = $event)),
              placeholder: "Message"
            }, null, 512), [
              [_vModelText, _ctx.inviteMsg]
            ]),
            _createElementVNode("input", {
              class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
              type: "submit",
              value: "Send",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sendInvite()))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPDF)
      ? (_openBlock(), _createBlock(_component_pdf_pop_up, {
          key: 1,
          onClose: _cache[13] || (_cache[13] = () => { _ctx.showPDF = false }),
          url: _ctx.pdfURL
        }, null, 8, ["url"]))
      : _createCommentVNode("", true),
    (_ctx.showAddEditUser)
      ? (_openBlock(), _createBlock(_component_add_edit_public_user, {
          key: 2,
          user: _ctx.userToEdit,
          onClose: _cache[14] || (_cache[14] = () => { _ctx.showAddEditUser = false; _ctx.getUsers() })
        }, null, 8, ["user"]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 3,
          onConfirm: _cache[15] || (_cache[15] = ($event: any) => (_ctx.deleteUserConfirm())),
          onCancel: _cache[16] || (_cache[16] = () => { _ctx.showConfirmDelete = false; }),
          msg: "Are you sure you would like to delete this user?"
        }))
      : _createCommentVNode("", true)
  ]))
}